"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _AddEmbedButton = _interopRequireDefault(require("./AddEmbedButton"));

var _constants = require("composer-plugins/lib/constants");

var embedButtonBuilder = function embedButtonBuilder(useUnstyledButton) {
  return function (_ref) {
    var auth = _ref.auth,
        onInsertEmbed = _ref.onInsertEmbed;
    return _react.default.createElement(_AddEmbedButton.default, {
      enableCodeTab: auth.gates.has(_constants.OPEN_EMBED_GATE),
      onChange: onInsertEmbed,
      useUnstyledButton: useUnstyledButton
    });
  };
};

embedButtonBuilder.propTypes = {
  auth: _propTypes.default.object.isRequired,
  onInsertEmbed: _propTypes.default.func.isRequired
};
var _default = embedButtonBuilder;
exports.default = _default;
module.exports = exports.default;